<template>
  <img id="backgroundImage" :src="$store.getters.pageSvg()" :width="$store.getters.pageWidth()"
    :height="$store.getters.pageHeight()" draggable="false">
</template>

<script>
  export default {
    name: 'page-background',

    beforeDestroy () {
      this.$store.commit('setOutputPath', '')
    }
  }
</script>

<style lang="scss" scoped>
  #backgroundImage {
    position: relative;
    box-shadow: 5px 4px 9px -3px rgba(0,0,0,0.8);
    border: 1px solid black;
    margin-top: 20px;
    margin-bottom: 70px;
    margin-left: 60px;
    margin-right: 60px;
    // transform: translateX(-50%);
  }
</style>



// WEBPACK FOOTER //
// src/components/editor/main/PageBackground.vue